import { format } from 'date-fns';
import { IDataTableColumn } from '../../../modules/dataTable/DataTable/model';

const columns: IDataTableColumn<any>[] = [
  {
    name: 'Rfid ID',
    selector: 'rfid_id',
    sortable: true,
    grow: 1.1,
  },
  {
    name: 'Rfid Name',
    selector: 'rfid_name',
    sortable: true,
    grow: 1.1,
  },
  {
    name: 'Rfid Code',
    selector: 'rfid_code',
    sortable: true,
    cell: (row: any) => <p>********</p>,
    grow: 1.1,
  },
  {
    name: 'Comment',
    selector: 'rfid_comment',
    sortable: true,
    cell: (row: any) => <p style={{ maxHeight: 70, overflowY: 'auto' }}>{row.rfid_comment}</p>,
  },
  {
    name: 'Active',
    selector: 'active',
    sortable: true,
    grow: 0.6,
    cell: (row: any) => <p>{row.active === 'True' ? 'Yes' : 'No'}</p>,
  },
];

export default columns;
